import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Typography from '@material-ui/core/Typography'

import { Loader, Button } from '../../common'
import TextArea from '../../common/TextArea'
import FeedItems from '../../containers/FeedItems'

import * as Constants from '../../../helpers/Constants'
import * as dataActions from '../../actions/Data'
import * as newsFeedActions from '../../actions/NewsFeed'
import * as configActions from '../../actions/Config'
import * as Strings from './strings'

class NewsFeed extends React.Component {
  state = {
    postInput: ''
  }

  componentDidMount() {
    const { data } = this.props

    this.fetch()
  }

  fetch() {
    const { user, data } = this.props

    if (!data.postsFetched) {
      this.props.tryGetPosts(user.token, data.community.id)
    }
  }

  requestCreatePost() {
    const { postInput } = this.state
    const { user, data } = this.props

    this.setState({ postInput: postInput.trim() })

    if (postInput.trim() === '') {
      this.props.showAlert(
        Strings.default.EMPTY_POST_HEADER,
        Strings.default.EMPTY_POST,
        Constants.ONE_BUTTON,
        { title: Strings.default.OK, onPress: () => {} }
      )
    } else {
      const postData = { text: postInput }

      this.props.showAlert(
        Strings.default.REQUEST_SEND_POST_HEADER,
        Strings.default.REQUEST_SEND_POST,
        Constants.TWO_BUTTONS,
        {
          title: Strings.default.NO,
          onPress: () => {}
        },
        {
          title: Strings.default.YES,
          onPress: () =>
            this.props.tryCreatePost(
              user.token,
              data.community.id,
              postData,
              () => this.onSuccess(),
              (h, i, t, b) => this.props.showAlert(h, i, t, b)
            )
        }
      )
    }
  }

  onSuccess() {
    this.props.showAlert(
      Strings.default.POST_CREATED_HEADER,
      Strings.default.POST_CREATED,
      Constants.ONE_BUTTON,
      { title: Strings.default.OK, onPress: () => {} }
    )

    this.setState({ postInput: '' })
  }

  render() {
    const { postInput } = this.state
    const { classes, data, newsFeed } = this.props

    if (!data.postsFetched) {
      return (
        <main className={classes.content}>
          <Loader />
        </main>
      )
    }

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <TextArea
          placeholder={Strings.default.NEW_POST + '*'}
          helperText={Strings.default.NEW_NEWS_INFO}
          value={postInput}
          onChange={text => this.setState({ postInput: text })}
        />
        <div className={classes.buttonContainer}>
          <Button
            onClick={() => this.requestCreatePost()}
            header={Strings.default.SEND}
            loading={newsFeed.isCreating}
            style={{ width: '30%', minWidth: 150 }}
          />
        </div>
        <Typography variant={'title'} className={classes.header}>
          {Strings.default.ALL_POSTS}
        </Typography>
        <FeedItems />
      </main>
    )
  }
}

const Styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  header: {
    marginTop: 25
  }
})

NewsFeed.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user, newsFeed }) {
  return { data, user, newsFeed }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...dataActions, ...newsFeedActions, ...configActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(NewsFeed)



// WEBPACK FOOTER //
// ./src/components/pages/NewsFeed/index.js